// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import { space } from 'styled-system'
import * as AccountStyles from 'styles/account'
import { ArtworksList, NoResults } from 'components/Artworks/styles/list'
// Elemnts
export const Bold = styled.p`
  margin: 0;
  ${space};
  font-size: ${(props) => props.theme.fontSizes[3]}px;
  line-height: 1.3em;
  color: ${(props) => props.theme.colors.default};
  font-weight: bold;
`
export const InitialLoad = styled.h2`
  color: ${(props) => props.theme.colors.default};
  font-size: 30px;
  font-weight: 400;
  text-align: center;
  width: 100%;
  margin: 50px auto;
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    font-size: 24px;
    margin: 50px auto;
  }
`
export const Button = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.theme.fontSizes[2]}px;
  color: ${(props) => props.theme.colors.default};
  border: 1px solid ${(props) => props.theme.colors.borderLight};
  min-width: 100px;
  min-height: 46px;
  padding: 10px 15px;
  cursor: pointer;
  transition: 0.2s ease color, 0.2s ease-in-out background;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.blue};
    color: ${(props) => props.theme.colors.blue};
    svg {
      path {
        stroke: ${(props) => props.theme.colors.blue};
        fill: ${(props) => props.theme.colors.blue};
      }
    }
  }
  svg {
    margin-right: 10px;
    path {
      stroke: ${(props) => props.theme.colors.default};
      fill: ${(props) => props.theme.colors.default};
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    font-size: ${(props) => props.theme.fontSizes[3]}px;
  }
  ${(props) =>
    props.blue &&
    `
    border: 1px solid ${props.theme.colors.blue};
    color: ${props.theme.colors.blue};
    svg {
      path {
        stroke: ${props.theme.colors.blue};
      }
    }
  `}
`

const BaseLayout = (props) => `
  position: relative;
  justify-content: space-between;
  flex: 1;
  width: 100%;
  min-height: 400px;
  /* max-width: ${props.theme.maxWidth}; */
  padding: 0 30px;

  @media (max-width: ${props.theme.maxWidth}) {
    padding: 0 15px;
  }
`

export const Breadcrumbs = styled(AccountStyles.Row)`
  justify-content: flex-start;
  padding: ${(props) => props.theme.space[1]}px 0 ${(props) => props.theme.space[3]}px;
  margin: ${(props) => props.theme.space[2]}px 0;
  a,
  span {
    font-size: 12px;
    font-weight: 700;
    padding: ${(props) => props.theme.space[1]}px 0 ${(props) => props.theme.space[1]}px
      ${(props) => props.theme.space[1]}px;
  }
  a {
    color: ${(props) => props.theme.colors.gray};
    text-decoration: none;
    &::after {
      margin-left: ${(props) => props.theme.space[1]}px;
      content: '/';
      display: inline-block;
    }
    &:first-child {
      padding: ${(props) => props.theme.space[1]}px 0;
    }
  }

  span {
    color: ${(props) => props.theme.colors.default};
  }
`
export const MainContent = styled(AccountStyles.Row)`
  align-items: flex-start;
  margin-bottom: 50px;
`
export const FeatureLayout = styled(AccountStyles.Column)`
  ${(props) => BaseLayout(props)};
  [role='button'] {
    outline: none;
  }
  hr {
    margin-bottom: ${(props) => props.theme.space[3]}px;
  }
  ${ArtworksList},
  ${NoResults} {
    ${(props) => props.initialLoad && `display: none;`}
  }
`
const { Column, Row, P, Link, Spacer } = AccountStyles
export { Column, Row, P, Link, Spacer }
